import React, { ReactElement, useCallback, useState } from 'react';
import useModalRouter from '../../common/hooks/useModalRouter';
import { IonModal } from '@ionic/react';
import collect from 'collect.js';
import { Modals } from '../../exports/Enums';

const ModalRoute = (): ReactElement | null => {
  const { config, isOpen, findModal, closeModal, dismissModal, goBack, openModal } = useModalRouter();
  const [showBackdrop, setShowBackdrop] = useState(true);

  const getModal = useCallback(() => {
    const modal = findModal(config?.id);
    if (!modal) return null;

    return modal.component;
  }, [config]);

  const modal = getModal();
  if (!modal) return null;

  return (
    <IonModal
      key={config.id}
      isOpen={isOpen}
      initialBreakpoint={config?.presentation?.initialBreakpoint}
      breakpoints={config?.presentation?.breakpoints}
      className={config?.presentation?.cssClass as string}
      onDidDismiss={() => {
        setShowBackdrop(true);
        dismissModal();
      }}
      onWillDismiss={() => setShowBackdrop(false)}
      showBackdrop={showBackdrop}
      // The menu-item sheet keeps its footer close to the sheet's gesture zones; a tap
      // that misses the Add To Cart button must not dismiss the whole flow.
      backdropDismiss={config.id !== Modals.MenuItem}
      style={{
        '--height': collect(config?.presentation).keys().isNotEmpty() ? 'auto' : '',
      }}
      onDidPresent={() => config?.onDidPresent?.()}
    >
      {React.createElement(modal, {
        openModal,
        goBack,
        // Bind the close to the modal id this instance was mounted with — components fire
        // close from timers/effects, which must never close a different, newer modal.
        closeModal: () => closeModal(config.id),
        ...config?.props,
      })}
    </IonModal>
  );
};

export default ModalRoute;
